const state = {
  room: JSON.parse(localStorage.getItem('room')),
  viewNewChatFlg: JSON.parse(localStorage.getItem('viewNewChatFlg'))
}

const mutations = {
  onUpdateCurrentRoom (state, room) {
    state.room = room
    localStorage.setItem('room', JSON.stringify(room))
  },
  onUpdateViewNewChatFlg (state, reload) {
    state.viewNewChatFlg = reload
    localStorage.setItem('viewNewChatFlg', JSON.stringify(reload))
  }
}

const actions = {
  setCurrentRoom (context, room) {
    let newRoom = !room ? null : {
      id: room.roomId,
      accessToken: room.roomAccessToken
    }
    context.commit('onUpdateCurrentRoom', newRoom)
  },
  setViewNewChatFlg (context, reload) {
    context.commit('onUpdateViewNewChatFlg', reload)
  }
}

const getters = {
  currentRoom: state => state.room,
  chatEnabled: state => state.chatEnabled,
  viewNewChatFlg: state => state.viewNewChatFlg
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/room.js